import { AuthRefresh } from 'types/AuthRefresh';
import { axiosClient } from './axiosClient';

const resource = 'auth';

const auth = {
  RefreshToken() {
    return axiosClient.get<AuthRefresh>(`${resource}/refresh`, {
      responseType: 'json',
    });
  },
};

export default auth;
